<template>
<div>
  <el-card body-style="padding: 0;padding-right:2%;">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="queryForm.userName" placeholder="请输入用户名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="真实姓名" prop="realyName">
            <el-input v-model="queryForm.realyName" placeholder="请输入姓名"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证" prop="idCardNumber">
            <el-input v-model="queryForm.idCardNumber" placeholder="请输入身份证"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="上级用户" prop="upUserName">
            <el-input v-model="queryForm.upUserName" placeholder="请输入上级用户"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="所属业务员" prop="businessName">
            <el-input v-model="queryForm.businessName" placeholder="请输入业务员"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核状态" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择用户类型">
              <el-option
                  v-for="item in statusOptions"
                  :key="item.flag"
                  :label="item.value"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-card>
    <el-button  type="primary" size="mini" style="margin: 0 0 10px 20px" icon="el-icon-warning-outline"
                @click="handleReviewBatch">批量审核</el-button>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="userName" label="用户名" />
      <el-table-column prop="upUserName" label="上级用户" />
      <el-table-column prop="businessName" label="业务员" />
      <el-table-column prop="realyName" label="真实姓名" />
      <el-table-column prop="userSexStr" label="性别" />
      <el-table-column prop="idCardNumber" label="身份证" width="162"/>
      <el-table-column prop="idCardStatusStr" label="身份证状态" />
      <el-table-column prop="commitDateTime" label="提交时间" width="120"/>
      <el-table-column prop="operationUser" label="操作人" />
      <el-table-column prop="reviewBecause" label="审核原因" />
      <el-table-column prop="reviewTime" label="审核时间" width="120"/>
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="success"
                     @click="addRemarks(scope.$index, scope.row)">
            备注
          </el-button>
          <el-button size="mini" type="success"
                     @click="idcardReview(scope.$index, scope.row)">
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
      <el-form-item label="备注">
        <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitRemarks()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogReviewTitle" :visible.sync="dialogReviewFormVisible">
    <el-form ref="dialogReviewForm" :model="dialogReviewForm" label-width="220px">
      <el-form-item label="审核操作">
        <el-select v-model="dialogReviewForm.reviewStatus" clearable size="mini">
          <el-option
              v-for="item in options"
              :key="item.status"
              :label="item.statusName"
              :value="item.status"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核原因">
        <el-input v-model="dialogReviewForm.reviewBecause" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitReviewStatus" size="mini" type="primary">提交</el-button>
      <el-button @click="handleReviewCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  addOrChangeIdCardRemarks,
  changeBatchIdcardStatus,
  getCustomerIdCard
} from "../../api/b2cbusiness/b2c_customerinfo";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "IdCardList",
  mixins:[MixinCUD,  MinxinScroll],
  data(){
    return {
      tableData:[],
      statusOptions: [
        {
          flag:"202111300003" ,
          value:"审核通过",
        },
        {
          flag: "202111300002" ,
          value:"审核未通过",
        },
        {
          flag: "202111300001" ,
          value:"未审核",
        }
      ],
      queryFormRefName:"queryForm",
      queryForm:{
        userName: '',
        realyName: '',
        idCardNumber: '',
        upUserName: '',
        businessName: '',
        status: ''
      },
      options:[{
        status:"202111300002",
        statusName:"未通过"
      },
        {
          status:"202111300003",
          statusName:"通过"
        }],
      dialogFormVisible: false,
      dialogTitle: "添加备注",
      dialogRefName: "dialogForm",
      dialogForm:{
        remarks:"",
      },
      dialogReviewFormVisible: false,
      dialogReviewTitle: "批量审核",
      dialogReviewRefName: "dialogReviewForm",
      dialogReviewForm:{
        reviewStatus:"202111300002",
        reviewBecause:"",
      },
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    if (this.$route.query.status != undefined && this.$route.query.status != null){
      this.queryForm.status = this.$route.query.status;
    }
    getCustomerIdCard(this.queryForm, this.pagination).then(res=>{
      if (res.success){
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    submitReviewStatus(){
      changeBatchIdcardStatus({idCardAry:this.multipleSelection, reviewInfo:this.dialogReviewForm}).then(res=>{
        if (res.success){
          this.dialogReviewFormVisible = false;
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleReviewBatch(){
      this.dialogReviewFormVisible = true;
    },
    idcardReview(index, data){
      console.log(data)
      this.$router.push({path:"/home/idcardetail", query: {idCardId:data.idCardId}})
    },
    handleReviewCloseDialog(){
      this.$refs[this.dialogReviewRefName].resetFields();
      this.dialogReviewFormVisible = false;
    },
    addRemarks(index, data){
      this.dialogForm.idCardId = data.idCardId;
      this.dialogFormVisible = true;
    },
    getData(){
      getCustomerIdCard(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitRemarks(){
      addOrChangeIdCardRemarks(this.dialogForm).then(res=>{
        if (res.success){
          this.dialogFormVisible = false;
          this.$message.success("添加成功")
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
